import "../../../../content/departments/industries/industries.css";
import * as React from 'react';
export default {
  React
};